module.exports = __webpack_public_path__ + "static/media/more.9c9c3516.svg";